module.exports = __webpack_public_path__ + "assets/5a3d025a1436aba009906579cca27e9d.svg";